import React from 'react';
import * as routes from 'app/api/redux-route/routes';
import { Switch, withRouter } from 'react-router-dom';
import PrivateRoute from '../route/PrivateRoute';
import HomePage from '../pages/home/HomePage';
import ReaderPage from '../pages/reader/ReaderPage';
import withLoading from 'app/ui/core/common/withLoading';
import RouteTransition from './RouteTransition';
import { isTeacher } from '../../api/redux-bridge/session/selectors';
import RedirectOnce from 'app/ui/route/RedirectOnce';
import DevRoute from '../route/DevRoute';
import SimpleRoute from '../route/SimpleRoute';
import CookieRoute from '../route/CookieRoute';
import TeacherRoute from '../route/TeacherRoute';
import { connect } from 'react-redux';
import { isIENotEdge } from '../../utils/browser';
import TokenRoute from '../route/TokenRoute';
import * as loginPages from '../pages/login';
import { isTeacherPortalEnabled } from '../../api/redux-watson/watson-config-selectors';
import LoginRedirect from 'app/ui/pages/redirect/LoginRedirect';
// Load the system error outright so we can show it even if something blows up with code splitting
import SystemError from 'app/ui/pages/error/SystemError';
import ForwardToBookshelf from 'app/ui/pages/redirect/ForwardToBookshelf';

const CookieError = withLoading(() => import('../pages/error/CookieError'));
const BookNotFound = withLoading(() => import('../pages/error/BookNotFound'));
const BookAccessDenied = withLoading(() =>
  import('../pages/error/BookAccessDenied')
);
const FileNotFound = withLoading(() => import('../pages/error/FileNotFound'));
const NoGroups = withLoading(() => import('../pages/error/NoGroups'));
const AdminPage = withLoading(() => import('../pages/admin/AdminPage'));
const WebView = withLoading(() => import('../pages/webview/WebView'));
const ThemeViewer = withLoading(() => import('../pages/dev/ThemeViewer'));
const BrandViewer = withLoading(() => import('../pages/dev/BrandViewer'));
const LocaleViewer = withLoading(() => import('../pages/dev/LocaleViewer'));
const RedirectPage = withLoading(() =>
  import('../pages/redirect/RedirectPage')
);
const BookshelfReaderRedirectPage = withLoading(() =>
  import('../pages/redirect/BookshelfReaderRedirectPage')
);
const AssignmentCreatorRedirect = withLoading(() =>
  import('../pages/redirect/AssignmentCreatorRedirect')
);
const JigsawLibrary = withLoading(() => import('../pages/dev/JigsawLibrary'));

class Pages extends React.Component {
  render() {
    const switchStatement = (
      <Switch location={this.props.location}>
        <CookieRoute
          bridgeRequired
          path={routes.LOGIN}
          exact
          component={loginPages.StudentLoginPage}
        />
        <CookieRoute
          bridgeRequired
          path={routes.LOGIN_TEACHER}
          exact
          component={loginPages.TeacherLoginPage}
        />
        <CookieRoute
          path={routes.RESET_PASSWORD}
          exact
          component={loginPages.ResetPassword}
        />
        <CookieRoute
          path={routes.CREATE_ACCOUNT}
          exact
          component={loginPages.CreateAccount}
        />
        <TokenRoute
          path={routes.COMPLETE_ACCOUNT}
          exact
          component={loginPages.CompleteAccount}
        />
        <TokenRoute
          path={routes.UPDATE_PASSWORD}
          exact
          component={loginPages.UpdatePassword}
        />
        <SimpleRoute path={routes.COOKIE_ERROR} exact component={CookieError} />
        <SimpleRoute
          path={routes.BOOK_NOT_FOUND}
          exact
          component={BookNotFound}
        />
        <SimpleRoute path={routes.SYSTEM_ERROR} exact component={SystemError} />
        <SimpleRoute
          path={routes.FILE_NOT_FOUND}
          exact
          component={FileNotFound}
        />
        <SimpleRoute path={routes.NO_GROUPS} exact component={NoGroups} />
        <SimpleRoute
          path={routes.BOOK_ACCESS_DENIED}
          exact
          component={BookAccessDenied}
        />
        <PrivateRoute path={routes.HOME} component={HomePage} bridgeRequired />
        <SimpleRoute path={routes.REDIRECT} exact component={RedirectPage} />
        <SimpleRoute
          path={routes.BOOKSHELF_READER_REDIRECT}
          exact
          component={BookshelfReaderRedirectPage}
        />
        <SimpleRoute
          path={routes.ASSIGNMENT_CREATOR}
          exact
          component={AssignmentCreatorRedirect}
        />
        <PrivateRoute path={routes.READER} component={ReaderPage} />
        {this.props.hasTeacherPortal && (
          <TeacherRoute path={routes.ADMIN} component={AdminPage} />
        )}
        <DevRoute path={routes.DEV_THEME} exact component={ThemeViewer} />
        <DevRoute path={routes.DEV_BRAND} exact component={BrandViewer} />
        <DevRoute path={routes.DEV_LOCALE} exact component={LocaleViewer} />
        <DevRoute
          path={routes.DEV_JIGSAW_LIBRARY}
          exact
          component={JigsawLibrary}
        />
        <SimpleRoute path={routes.WEBVIEW} component={WebView} />
        <SimpleRoute path={routes.LOGIN_REDIRECT} component={LoginRedirect} />
        <SimpleRoute
          path={routes.DEFAULT}
          exact
          render={() => {
            if (this.props.teacher && this.props.hasTeacherPortal) {
              return <RedirectOnce to={routes.ADMIN} />;
            }
            return <RedirectOnce to={routes.HOME} />;
          }}
        />
        <PrivateRoute path={routes.DECIDE} component={ForwardToBookshelf} />
        <RedirectOnce to={routes.FILE_NOT_FOUND} />
      </Switch>
    );

    if (isIENotEdge()) {
      return switchStatement;
    }
    return (
      <RouteTransition location={this.props.location}>
        {switchStatement}
      </RouteTransition>
    );
  }
}

const mapStateToProps = state => ({
  teacher: isTeacher(state),
  hasTeacherPortal: isTeacherPortalEnabled(state),
});

export default withRouter(connect(mapStateToProps)(Pages));



// WEBPACK FOOTER //
// ./src/app/ui/main/Pages.js